import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Presentacion } from '../../../../interfaces/presentacion.interface';
import { environment } from 'src/environments/environment';
import { KeycloakService } from 'keycloak-angular';
import Swal from 'sweetalert2';
import { UtilService } from 'src/app/common/services/util.service';
import { RegistroService } from 'src/app/registro.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-productQuery',
    templateUrl: './product-query.component.html',
    styleUrls: ['./product-query.component.css'],
})
export class ProductQueryComponent {
    products = [];
    busqueda = '';
    accessToken = '';
    presentaciones: Presentacion[];
    currentProduct = {
        id: null,
        nombre: '',
    };

    currentProductEdit = {
        nombre: '',
        casaProductora: '',
        numeroRegistroIca: '',
        productoId: null,
    };
    load: boolean;

    private apiUrl: string = environment.apiSiriUrl;
    constructor(
        private router: Router,
        private http: HttpClient,
        private keycloakService: KeycloakService,
        private utilService: UtilService,
        private registroService: RegistroService,
        private translate: TranslateService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    ngOnInit() {
        this.keycloakService.getToken().then((token) => {
            this.accessToken = token;
        });
        this.loadProducts();
    }

    loadProducts() {
        const headers = new HttpHeaders().set(
            'Authorization',
            `Bearer ${this.accessToken}`
        );

        /*console.log("${this.apiUrl}producto/agente-vigilado/${this.registroService.empresaSelected} ", `${this.apiUrl}producto/agente-vigilado/${this.registroService.empresaSelected}`) */
        this.http
            .get<
                any[]
            >(`${this.apiUrl}producto/agente-vigilado/${this.registroService.empresaSelected}`, { headers })
            .subscribe(
                (response) => {
                    this.products = response.sort((a, b) => {
                        const comparison = a.tipoProducto.nombre.localeCompare(
                            b.tipoProducto.nombre
                        );
                        if (comparison !== 0) return comparison;
                        return a.numeroRegistroIca - b.numeroRegistroIca;
                    });
                },
                (error) => {
                    console.error('Error al cargar productos', error);
                }
            );
    }

    mostrarTexto() {
        this.translate
            .get('productoConsulta.alertaAyuda')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }

    verPresentaciones(producto) {
        this.router.navigate([`${producto.id}/presentaciones`], {
            state: { currentProduct: producto },
        });
    }

    editarProducto(producto: any) {
        this.currentProductEdit = producto;
        this.router.navigate(['editar-producto/' + producto.id]);
    }

    activarInactivar(producto: any) {
        const formData = {
            activo: !producto.estado,
        };

        this.http
            .put(`${this.apiUrl}producto/activar/${producto.id}`, formData)
            .subscribe(
                (response) => {
                    this.utilService.displaySpinner = true;
                    setTimeout(() => {
                        this.loadProducts();
                        this.utilService.displaySpinner = false;
                    }, 2000);
                },
                (error) => {
                    console.error(
                        'Error al cargar opciones de Dropdown 2',
                        error
                    );
                }
            );
    }

    togglePresentaciones(producto: any) {
        producto.showPresentaciones = !producto.showPresentaciones;
    }
    addProduct() {
        this.router.navigate(['nuevo-producto/']);
    }

    formatUnidadMedida(cantidad: number, unidad: string): string {
        return cantidad > 1 ? `${unidad}s` : unidad;
    }
}
